<form [formGroup]="form" (ngSubmit)="submitForm()">
  <ng-container *ngIf="this.data.mode === 'add'">
    <title mat-dialog-title>{{ 'vehicleIntelligence.hotlist.addPlateTo' | t: { name: data.hotlist.name } }}</title>
  </ng-container>
  <ng-container *ngIf="this.data.mode === 'edit'">
    <title mat-dialog-title>{{ 'vehicleIntelligence.hotlist.editPlate' | t }}</title>
  </ng-container>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [disabled]="form.invalid" type="submit" color="success">
      {{ (this.data.mode === 'add' ? 'common.add' : 'common.edit') | t }} {{ 'vehicleIntelligence.hotlist.plate' | t }}
    </button>
    <button mat-button color="danger" type="button" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  </mat-dialog-actions>
</form>
